<template>
  <div class="stepper anim-fade-in">
    <div class="d-flex f-column">
      <div class="stepper_inner">
        <div
          class="stepper_item"
          :class="{
            stepper_item_active: $route.name === 'SubscriptionPaymentSelection',
          }"
        >
          <v-icon color="primary"> mdi-format-list-checks </v-icon>
          {{ $t('payment.stepper_plan_selection') }}
        </div>
        <div class="arrow">
          <arrow />
        </div>
        <div
          class="stepper_item"
          :class="{
            stepper_item_active: $route.name === 'SubscriptionPaymentGate',
          }"
        >
          <!-- <v-icon color="primary"> mdi-credit-card-outline </v-icon> -->
          <v-icon color="primary">
            {{
              currentPlan.tier === 'TRIAL' || currentPlan.tier === 'FREE'
                ? 'mdi-credit-card-outline'
                : 'mdi-credit-card'
            }}
            mdi-credit-card-outline
          </v-icon>
          {{
            currentPlan.tier === 'TRIAL' || currentPlan.tier === 'FREE'
              ? $t('payment.stepper_payment')
              : $t('payment.stepper_payment_update')
          }}
        </div>
        <div class="arrow">
          <arrow />
        </div>
        <div
          class="stepper_item"
          :class="{
            stepper_item_active: $route.name === 'SubscriptionPaymentConfirmation',
          }"
        >
          <v-icon color="primary"> mdi-check </v-icon>
          {{ $t('payment.stepper_confirmation') }}
        </div>
      </div>
      <div
        v-if="!productionEnv"
        class="w-100 mt-2 text-center"
      >
        Current plan provider: <span class="clr-primary">{{ currentPlan.provider }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import arrow from '@/assets/payment/arrow.svg'
import payment_mix from '@/mixins/payment_mix'

export default {
  name: 'PaymentStepper',
  components: {
    arrow,
  },
  mixins: [payment_mix],
  computed: {
    productionEnv() {
      return import.meta.env.VITE_ENV === 'production' && import.meta.env.VITE_BRANCH === 'master'
    },
    canCheckout() {
      return Object.keys(this.completed).every(key => this.completed[key])
    },
  },
}
</script>

<style lang="scss" scoped>
.stepper {
  display: flex;
  color: #d1d1d1;
  &_inner {
    display: flex;
    // background: red;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &_item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    width: 8rem;
    padding: 1rem 0;
    border-radius: 8px;
    transition: 0.4s;
    &_active {
      // background: #333333;
      background: rgb(0, 0, 0, 0.5);
    }
  }
}
.arrow {
  margin: 0 1rem;
  svg {
    // stroke: var(--clr-dvider);
    stroke: grey;
  }
  // background: red;
}
</style>
